import { createBrowserRouter } from 'react-router-dom';
import {
  APIkey,
  ContactUs,
  Credit,
  Dashboard,
  OnscreenApiWrapper,
  Profile,
  Register,
  ResetPassword,
  VaultTable,
  DigilockerCallback,
  AccessDenied
} from '../pages';
import { Playground } from '../pages/api-playground';
import { DetailedLogs } from '../pages/detailed-logs';
import { AuthGuard } from '../utils';
import { APIDocument, Layout, ViewLogs } from '../components';
import { ProductCatalog} from '../components/product-catalog';
import { Billtable } from '../pages/Billingdetail.js';
import { GuestGuard } from '../utils/route-guard/GuestGuard';
import NavigateProvider from "./AppWrapper"; 
import { NotFound } from '../pages/default/NotFound.js';

const router = createBrowserRouter([
  {
    path: '/',
    element: <NavigateProvider />, 
    children: [
      {
        path: '/',
        element: (
          <AuthGuard>
            <Layout />
          </AuthGuard>
        ),
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            path: '/view-logs',
            element: <ViewLogs />,
          },
          {
            path: '/detailed-logs',
            element: <DetailedLogs />,
          },
          {
            path: '/api-catalogue',
            element: <OnscreenApiWrapper />,
          },
          {
            path: '/product-catalogue',
            element: <ProductCatalog />,
          },
          {
            path: '/api-document',
            element: <APIDocument />,
          },
          {
            path: '/api-key',
            element: <APIkey />,
          },
          {
            path: '/profile',
            element: <Profile />,
          },
          {
            path: '/credit-balance',
            element: <Credit />,
          },
          {
            path: '/contact-us',
            element: <ContactUs />,
          },
          {
            path: '/billing',
            element:
              <GuestGuard requiredRole="admin">
                <Billtable />
              </GuestGuard>,
          },
          {
            path: '/vault',
            element: <VaultTable />,
          },
          {
            path: '/api-playground',
            element: <Playground />,
          },
        ],
        },
        {
          path: '/login',
          element: <Register />,
        },
        {
          path: '/magic-login',
          element: <Register />,
        },
        {
          path: '/reset-password',
          element: <ResetPassword />,
        },
        {
          path: '/callback',
          element: <DigilockerCallback />,
        },
        {
          path: '/unauthorized',
          element: <AccessDenied />,
        },
        {
          path: "*" ,
          element: <NotFound />
        },
    ],
  },
]);
export default router;
